"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._EndEvent = {
    type: "structure",
    required: [],
    members: {}
};
//# sourceMappingURL=_EndEvent.js.map